import React from "react";

import { Grid } from "@material-ui/core";
import TextField from '@mui/material/TextField';
import KeyWords from "./keywords";
import Autocomplete from '@mui/material/Autocomplete';
import InputMask from 'react-input-mask';

export default function Details({ place, categories, disable, onChange, options = {} }) {
 
  const lookForCategory = () => {
    var placeCategory = null;
    if (place != null && categories != null && place.placeCategory != null) {
      categories.forEach((category) => {
        if (category.descriptor === place.placeCategory.descriptor)
          placeCategory = category;
      });
    }
    return placeCategory;
  }

  const onChangeOwnerDni = (event) => {
    place.setOwnerDni(event.target.value.replaceAll(/\s/g, '').replaceAll('-','').replaceAll('_',''));
    setOwner(place.ownerDni);
    onChange();
  }

  const onChangeCategory = (event, newValue) => {
    place.setCategory(newValue);
    setCategory(newValue);
    onChange();
  }

  const onChangeName = (event) => {
    let trimmed = event.target.value.trim();
    place.name = trimmed ? trimmed : null
    setName(event.target.value);
    onChange();
  }

  const onChangeDescription = (event) => {
    let trimmed = event.target.value.trim()
    place.description = trimmed ? trimmed : null
    setDescription(event.target.value);
    onChange();
  }

  const [owner, setOwner] = React.useState(place.ownerDni ? place.ownerDni : "");
  const [category, setCategory] = React.useState(lookForCategory());
  const [name, setName] = React.useState(place.name ? place.name : "");
  const [description, setDescription] = React.useState(place.description ? place.description : null);

  return (
    <Grid container spacing={2} >
      <Grid item xs={12} >
        <TextField
          required
          variant="outlined" 
          id="name"
          label="Nombre del lugar"
          error={!place.name}
          name="name"
          onChange={onChangeName}
          disabled={disable}
          value={name}
          fullWidth
          placeholder="Nombre del lugar"/>
      </Grid>
      <Grid item xs={6} >
        <Autocomplete 
          options={categories ? categories : []}
          disabled={disable}
          renderInput={(params) => <TextField error={!place.categoryId} required {...params} label="Categoría" />} 
          value={category}
          onChange={onChangeCategory}/>
      </Grid>
      { options.ownerDni !== 'hidden' ? (
        <Grid item xs={6} >
          <InputMask
            mask="99-99999999-9"
            onChange={onChangeOwnerDni}
            value={owner}
            disabled={disable}
            maskChar="_">
            { () =>   
              <TextField
                variant="outlined" 
                id="ownerDni"
                label="CUIL del propietario"
                name="ownerDni"
                error={place.ownerDni && place.ownerDni.toString().length !== 11}
                fullWidth
                placeholder="20-30123124-9"/>
            }
          </InputMask>
        </Grid> ) : (null)
      }
      { options.description !== 'hidden' ? (
        <Grid item xs={12} >
          <TextField
              variant="outlined" 
              id="description"
              disabled={disable}
              label="Descripción del lugar"
              name="description"
              multiline
              minRows={2}
              value={description}
              onChange={onChangeDescription}
              fullWidth
              placeholder="Una descripción del lugar..."/>
        </Grid> ) : (null)
      }
      { options.keywords !== 'hidden' ? (
        <Grid item xs={12} >
          <KeyWords place={place} disable={disable}/>
        </Grid> ) : (null)
      }
    </Grid>
  );
}
